/**
 * 管理后台「展示用」统一时区：尼日利亚拉各斯（无夏令时，UTC+1）
 */

import config from '@/config'

export const DISPLAY_TIMEZONE = config.timeZone

const WEEKDAY_ZH = ['日', '一', '二', '三', '四', '五', '六']

/**
 * 将某一时刻在指定 IANA 时区下的日历分量取出（用于 parseTime / formatTimestamp）
 * @param {Date} date
 * @param {string} timeZone IANA，如 Africa/Lagos
 * @returns {{ y: number, m: number, d: number, h: number, i: number, s: number, a: number }}
 *   a 为 0–6，周日为 0，与 Date#getDay 一致
 */
export function getCalendarPartsInTimeZone(date, timeZone) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return { y: 1970, m: 1, d: 1, h: 0, i: 0, s: 0, a: 0 }
  }

  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
    hourCycle: 'h23',
    weekday: 'short',
  })

  const parts = dtf.formatToParts(date)
  const map = {}
  for (let i = 0; i < parts.length; i += 1) {
    const p = parts[i]
    if (p.type !== 'literal') {
      map[p.type] = p.value
    }
  }

  const y = Number(map.year)
  const m = Number(map.month)
  const d = Number(map.day)
  const h = Number(map.hour)
  const i = Number(map.minute)
  const s = Number(map.second)

  // weekday short: Sun, Mon, ... → 0–6
  const wd = String(map.weekday || '')
    .slice(0, 3)
    .toLowerCase()
  const wdMap = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 }
  const a = wdMap[wd] != null ? wdMap[wd] : date.getDay()

  return {
    y: Number.isFinite(y) ? y : date.getFullYear(),
    m: Number.isFinite(m) ? m : date.getMonth() + 1,
    d: Number.isFinite(d) ? d : date.getDate(),
    h: Number.isFinite(h) ? h : 0,
    i: Number.isFinite(i) ? i : 0,
    s: Number.isFinite(s) ? s : 0,
    a,
  }
}

export function weekdayZhShort(dayIndex) {
  return WEEKDAY_ZH[dayIndex] != null ? WEEKDAY_ZH[dayIndex] : ''
}
